import { ChangeDetectionStrategy, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from "@commonNodeModules/@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from '@commonNodeModules/@ngx-translate/core';
import { environment } from '@environments/environment';

@Component({
	selector: 'app-infoletter-header',
	templateUrl: './infoletter-header.component.html',
	styleUrl: './infoletter-header.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, TranslatePipe]
})
export class InfoletterHeaderComponent implements OnInit {

	@ViewChild("infoletterDropdown") infoletterDropdown: NgbDropdown;

	constructor() { }

	ngOnInit(): void {
	}

	public onHoverDropdown() {
		this.infoletterDropdown.open()
	}

	public onLeaveDropdown() {
		this.infoletterDropdown.close()
	}

	public get infoletterUrl() {
		return `${environment.infoletterUrl}`;
	}
}
